import React, { Component } from 'react';
import PageTitle from '../../../common/page-title';
import PipEposSubmissionsMissingWeeks from './pip-epos-submissions-missing-weeks';

class PipEposSubmissionsMissingWeeksPage extends Component {
  // eslint-disable-next-line class-methods-use-this
  render() {
    return (
      <div>
        <PageTitle>
          Epos Missing Weeks
        </PageTitle>
        <PipEposSubmissionsMissingWeeks />
      </div>
    );
  }
}

export default PipEposSubmissionsMissingWeeksPage;
